import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "../lib/auth";
import { AuthShell, AuthField } from "../components/AuthShell";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const res = await register(form);
    setBusy(false);
    if (res.ok) nav("/dashboard"); else setErr(res.error);
  };

  return (
    <AuthShell>
      <span className="overline">Create account</span>
      <h1 className="font-serif" style={{ fontSize: "clamp(2rem, 4vw, 2.8rem)", fontWeight: 500, letterSpacing: "-0.01em", margin: "12px 0 8px" }}>
        Start your <em style={{ fontStyle: "italic", color: "var(--secondary)" }}>selling</em> journey.
      </h1>
      <p style={{ color: "var(--text-muted)", marginBottom: 28, maxWidth: 440, lineHeight: 1.55 }}>
        Tell us who you are and we&rsquo;ll set up your personal seller dashboard.
      </p>
      <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 22 }}>
        <AuthField label="Your name" testid="register-name-input" value={form.name} onChange={update("name")} placeholder="Jane Seller" autoFocus />
        <AuthField label="Email" testid="register-email-input" type="email" value={form.email} onChange={update("email")} placeholder="you@example.com" />
        <AuthField label="Password" testid="register-password-input" type="password" value={form.password} onChange={update("password")} placeholder="At least 8 characters" />
        {err && <div data-testid="register-error" style={{ color: "var(--error)", fontSize: 14 }}>{err}</div>}
        <button data-testid="register-submit-btn" className="btn-primary" type="submit" disabled={busy} style={{ marginTop: 6, alignSelf: "flex-start" }}>
          {busy ? "Creating…" : <>Create account <ArrowRight size={16} /></>}
        </button>
      </form>
      <div style={{ marginTop: 28, color: "var(--text-muted)", fontSize: 14 }}>
        Already have an account?{" "}
        <Link data-testid="link-to-login" to="/login" style={{ color: "var(--primary)", fontWeight: 500 }}>Sign in</Link>
      </div>
    </AuthShell>
  );
}
